module.exports = __webpack_public_path__ + "img/progress-one-done.1351d550.png";